/* eslint-disable no-unused-vars */
import DefectPage from "layout/DefectPage";
import NotFound from "assets/image/NotFound.png";
import { useHistory } from "react-router-dom";
import { RefreshRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const ErrorPage = () => {
  const { t } = useTranslation(["translation"]);
  const history = useHistory();
  const propsNotFound = {
    title: t("defect.notfound"),
    descript: t("defect.notfounddesc"),
    image: NotFound,
    alt: "notfound",
    submit: t("refresh"),
    onSubmit: () => history.push("/mainmenu"),
    icon: <RefreshRounded />,
    isLayout: false
  };

  return <DefectPage {...propsNotFound} />;
};

export default ErrorPage;
